import React from 'react';
import SvgIcon from './SvgIcon';

const BombExplosive = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M14.5 12.758V9.5a1 1 0 00-1-1h-3a1 1 0 00-1 1v3.258M9.5 20.242V22.5a1 1 0 001 1h3a1 1 0 001-1v-2.258M9.5 12.758V9.5a1 1 0 00-1-1h-3a1 1 0 00-1 1v5M4.5 18.5v4a1 1 0 001 1h3a1 1 0 001-1v-2.258"
            stroke="currentColor"
            strokeWidth={0.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 21a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
            stroke="currentColor"
            strokeWidth={0.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.032 18.5H19.5a1 1 0 001-1v-2a1 1 0 00-1-1h-3.468M7.968 14.5H4.5a1 1 0 00-1 1v2a1 1 0 001 1h3.468M19.5 14.5v-5a1 1 0 00-1-1h-3a1 1 0 00-1 1v3.258M14.5 20.242V22.5a1 1 0 001 1h3a1 1 0 001-1v-4"
            stroke="currentColor"
            strokeWidth={0.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 21a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
            stroke="currentColor"
            strokeWidth={0.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.032 18.5H19.5a1 1 0 001-1v-2a1 1 0 00-1-1h-3.468M7.968 14.5H4.5a1 1 0 00-1 1v2a1 1 0 001 1h3.468M12 14v2.5h1.979M12 5v3.5M12 .5v1.979M15.37 2.02L13.89 3.331M16.466 5.553l-1.964-.243M8.545 2.02l1.483 1.311M7.451 5.553l1.964-.243"
            stroke="currentColor"
            strokeWidth={0.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

BombExplosive.displayName = 'BombExplosiveIcon';

export default BombExplosive;
